import styled from "@emotion/styled";
import { Content } from "src/atoms/Content";

export const ProductGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space?.space16};
  grid-column: span 3;

  @media (min-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: max-content max-content auto;
  }

  &.hideCategoryTree {
    grid-column: span 4;
  }
`;

export const ListingContainer = styled.div`
  display: grid;

  @media (min-width: ${({ theme }) => theme.breakpoints?.md}) {
    grid-gap: ${({ theme }) => theme.space?.space32};
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    grid-gap: ${({ theme }) => theme.space?.space32};
    grid-template-columns: 1fr;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.xl}) {
    grid-gap: ${({ theme }) => theme.space?.space24};
  }
`;

export const GridWrapper = styled.div`
  grid-column: span 3;

  &.hideCategoryTree {
    grid-column: span 4;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    grid-column: 1;
  }
`;

export const PromoWrapper = styled.div`
  position: relative;
  grid-column: span 3;
  display: grid;
  grid-template-rows: ${({ theme }) =>
    `minmax(${
      (theme.space?.space96 || "") +
      (theme.space?.space64 || "") +
      (theme.space?.space24 || "")
    }, 1fr)`};
  transition: all 250ms ease-in-out;
`;

export const CategoryTreeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space?.space24};

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: none;
  }
`;

export const NoResultsWrapper = styled.div`
  grid-column: span 3;
`;

export const PromotionBlockSkeletonWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors?.tone.white};
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space?.space24};
`;

export const StyledAuthBanner = styled.div<{ hideCategoryTree?: boolean }>`
  grid-column: span 2;

  @media (min-width: ${({ theme }) => theme.breakpoints?.sm}) {
    grid-column: ${({ hideCategoryTree }) =>
      hideCategoryTree ? "span 4" : "span 3"};
  }
`;

export const ContentContainer = styled(Content)`
  display: grid;
  grid-template-columns: minmax(0, 1264px);
  grid-template-rows: auto 1fr;
  row-gap: ${({ theme }) => theme.space?.space24};
  padding-block: ${({ theme }) => theme.space?.space32};
  min-width: 0;
  min-height: 100vh;

  &.no-padding-block {
    padding-block: 0;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space?.space24};

  &.no-gap {
    gap: 0;
  }

  &.no-margin {
    @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
      margin-inline: -${({ theme }) => theme.space?.space16};
    }
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  place-items: center;
  justify-content: center;
  row-gap: ${({ theme }) => theme.space?.space48};
  margin-block-start: ${({ theme }) => theme.space?.space16};
  margin-block-end: ${({ theme }) => theme.space?.space24};

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    row-gap: ${({ theme }) => theme.space?.space32};
    margin-block-start: ${({ theme }) => theme.space?.space8};
    margin-block-end: ${({ theme }) => theme.space?.space8};
  }

  &.no-padding-plp {
    margin-block-end: ${({ theme }) => theme.space?.space48};

    @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
      margin-block-end: ${({ theme }) => theme.space?.space32};
    }
  }
`;
